// This component is used to display a loading checkbox
// It accepts a promise as a prop and displays a loading spinner until the promise resolves

import { forwardRef, useState } from 'react';

import {
  Box,
  CircularProgress,
  IconButton,
  type IconButtonProps,
} from '@mui/material';

type LoadingIconButtonProps = {
  onClick: (event: React.MouseEvent) => Promise<any>;
  initialLoading?: boolean;
} & IconButtonProps;

export const LoadingIconButton = forwardRef<
  HTMLButtonElement,
  LoadingIconButtonProps
>(({ onClick, initialLoading = false, ...props }, ref) => {
  const [loading, setLoading] = useState<boolean>(initialLoading);

  const handleClick = async (event: React.MouseEvent) => {
    setLoading(true);
    try {
      await onClick(event);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {loading ? (
        <CircularProgress size={24} sx={{ m: '9px' }} disableShrink />
      ) : (
        <IconButton ref={ref} onClick={handleClick} {...props} />
      )}
    </Box>
  );
});
